import type { ComboboxItemDefault } from '@consta/uikit/Combobox'
import { Combobox } from '@consta/uikit/Combobox'
import { Informer } from '@consta/uikit/Informer'
import { Select } from '@consta/uikit/Select'
import type { TableColumn } from '@consta/uikit/Table'
import { Table } from '@consta/uikit/Table'
import { Text } from '@consta/uikit/Text'
import type { MarkerSetupType } from '@core/core/types'
import type { Nullable } from 'common/types'
import type { FC } from 'react'

import css from './Setup.css'
import type { AttributesTableProps } from './types'

type AttributeRowType = {
  id: keyof MarkerSetupType
  name: string
  required?: boolean
  value?: string
}

const attributes: AttributeRowType[] = [
  {
    id: 'wellNameColumn',
    name: 'Имя скважины',
    required: true,
  },
  {
    id: 'markerNameColumn',
    name: 'Имя маркера',
    required: true,
  },
  {
    id: 'markerTypeColumn',
    name: 'Тип маркера',
  },
  {
    id: 'markerBoreDepthColumn',
    name: 'Глубина по стволу',
    required: true,
  },
  {
    id: 'markerAbsDepthColumn',
    name: 'Глубина по абсолютным отметкам',
  },
]

export const AttributesTable: FC<AttributesTableProps> = ({ settings, contentRow, update }) => {
  const columnNumNames = contentRow.map<ComboboxItemDefault>((value, index) => ({
    id: index + 1,
    label: `${index + 1} - ${value}`,
  }))

  const setComboboxValue = (row: AttributeRowType, item: Nullable<ComboboxItemDefault>) => {
    const value = item !== null && typeof item.id === 'number' ? item.id : undefined
    update({ [row.id]: value })
  }

  const renderColumnNumberCell = (row: AttributeRowType) => {
    const status = row.required && settings[row.id] === undefined ? 'alert' : undefined
    const value = columnNumNames.find(value => value.id.toString() === row.value)
    if (row.required) {
      return (
        <div className={css.valueContainer}>
          <Select
            data-testid={`settings-${row.id}`}
            className={css.tableSelector}
            size="s"
            items={columnNumNames}
            value={value}
            status={status}
            placeholder="Выберите"
            onChange={value => {
              setComboboxValue(row, value)
            }}
          />
        </div>
      )
    }
    return (
      <div className={css.valueContainer}>
        <Combobox
          data-testid={`settings-${row.id}`}
          className={css.tableSelector}
          size="s"
          items={columnNumNames}
          value={value}
          status={status}
          placeholder="Выберите"
          onChange={value => {
            setComboboxValue(row, value)
          }}
        />
      </div>
    )
  }
  const attributeColumns: TableColumn<AttributeRowType>[] = [
    {
      title: (
        <Text view="ghost" size="xs">
          Атрибут
        </Text>
      ),
      accessor: 'name',
      width: 250,
    },
    {
      title: (
        <Text view="ghost" size="xs">
          № столбца
        </Text>
      ),
      accessor: 'value',
      renderCell: renderColumnNumberCell,
    },
  ]

  attributes.forEach(attr => {
    attr.value = settings[attr.id]?.toString()
  })
  const isAlRequiredFilled = !attributes.some(
    attribute => attribute.required && attribute.value === undefined,
  )
  return (
    <>
      <Table
        rows={attributes}
        columns={attributeColumns}
        getCellWrap={() => 'break'}
        size="m"
        stickyHeader={true}
        borderBetweenRows={true}
        className={`${css.codeFrameTraceHeaders} ${css.tableContainer}`}
      />
      {!isAlRequiredFilled && (
        <div className={css.informerContainer}>
          <Informer
            className={css.informer}
            view="bordered"
            status="system"
            label="Должны быть заполнены столбцы для всех обязательных атрибутов"
          />
        </div>
      )}
    </>
  )
}
